import { TextButton } from "../../../ui/input/TextButton";
import { ComponentF, createElement } from "../../../ui/ui";
import { withColor } from "../../../ui/uiText";
import { createAction } from "../../actions/Action";
import { useItem } from "../../actions/ActionItems";
import Colors from "../../Colors";
import { gameData, runPlayerAction } from "../../GameManager";
import { isDownKey, isUpKey } from "../keyHelper";

export const InventoryView: ComponentF<void> = (C) => {
  const [state, setState] = C.useState({ focus: false, selected: 0 });

  if (gameData.selectedSpell || gameData.target) {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y,
      `${withColor(Colors.GRAY_2, "Items")} ${withColor(Colors.GREEN_3, "-")}`
    );
  } else {
    C.display.drawText(
      C.bounds.x,
      C.bounds.y,
      `${withColor(
        state.focus ? Colors.EGGSHELL : Colors.GRAY_3,
        "Items"
      )} ${withColor(Colors.GREEN_3, "-")}`
    );
  }

  C.display.drawText(
    C.bounds.x,
    C.bounds.y,
    `${withColor(
      state.focus ? Colors.EGGSHELL : Colors.GRAY_3,
      "Items"
    )} ${withColor(Colors.GREEN_3, "-")}`
  );

  let y = C.bounds.y + 2;
  gameData.player.contains.forEach((item, index) => {
    const selected = state.focus && index === state.selected;
    if (selected) {
      gameData.selectedItem = item;
    }
    C.display.drawText(C.bounds.x, y, item.uses.toString());
    y += C.display.drawText(
      C.bounds.x,
      y,
      `${withColor(
        selected
          ? Colors.AQUA_3
          : state.focus
          ? Colors.EGGSHELL
          : Colors.GRAY_3,
        item.breed.name
      )} x${item.uses.toString()}`,
      C.bounds.w - 1
    );
  });

  C.handlers.press = (p: [number, number]) => {
    if (gameData.selectedSpell || gameData.target) {
      return false;
    }
    if (state.focus && p[1] === 0) {
      gameData.selectedItem = null;
      setState({ focus: false, selected: null });
      return;
    }
    const newSelected = p[1] - 2;
    if (newSelected >= 0 && newSelected < gameData.player.contains.size) {
      setState({
        focus: true,
        selected: newSelected,
      });
    } else {
      setState({
        focus: true,
        selected: 0,
      });
    }
  };

  C.handlers.keypress = (key: string) => {
    if (gameData.selectedSpell || gameData.target) {
      return false;
    }

    if (key === "-") {
      if (state.focus) {
        gameData.selectedItem = null;
      }
      setState({ focus: !state.focus, selected: 0 });
      return true;
    }

    if (state.focus) {
      if (key === "?") {
        return false;
      }
      if (isUpKey(key)) {
        setState({ selected: Math.max(0, state.selected - 1) });
      } else if (isDownKey(key)) {
        setState({
          selected: Math.min(gameData.player.contains.size, state.selected + 1),
        });
      } else if (key === "Escape") {
        gameData.selectedItem = null;
        setState({ focus: false, selected: 0 });
      }
      return true;
    }
    return false;
  };

  if (gameData.selectedItem) {
    return [
      createElement(
        TextButton,
        { x: 0, y: C.bounds.h - 1, w: C.bounds.w, h: 1 },
        {
          title: "Use",
          keyLabel: "Enter",
          keys: "Enter",
          disabled: gameData.selectedItem.uses === 0,
          onClick: () => {
            const item = gameData.selectedItem;
            gameData.selectedItem = null;
            setState({ selected: 0, focus: false });
            if (item && item.isUsable && item.breed.useAbility) {
              if (item.breed.useAbility.advancesTurn) {
                if (!gameData.actionPending) {
                  gameData.actionPending = true;
                  //Commands only have action results when they're a turn causing action
                  runPlayerAction(
                    createAction(useItem, gameData.player, { item })
                  ).then(() => {
                    gameData.actionPending = false;
                  });
                }
              } else {
                item.useItem(gameData.player);
              }
            }
          },
        }
      ),
    ];
  }
};
